/**
 * @file list-query.ts
 * @description Общие кирпичики состояния реестров в адресе страницы
 * (phase19.31): разбор чисел из адреса. Одно место для всех реестров —
 * заказы, товары, клиенты, сделки, документы; `crm-list-query.ts`
 * реэкспортирует отсюда (прежние импорты работают).
 */

/** Целое ≥ 1 из строки адреса; мусор — значение по умолчанию. */
export function positiveInt(raw: string | null, fallback: number): number {
  const value = Number(raw);
  return Number.isInteger(value) && value >= 1 ? value : fallback;
}
